/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { AxiosResponse, RawAxiosRequestHeaders } from 'axios';
import { CoreNetworking, type ApiClient } from '@airasia-rn/ui/core-networking';
import { Platform } from 'react-native';
import { SettingsResponse } from '../types';

class SettingsApiService {
  private readonly client: ApiClient;

  getHost(env: 'stg' | 'prd'): string {
    return env === 'prd'
      ? 'k.apiairasia.com/platform'
      : 'k.stg-apiairasia.com/platform';
  }

  constructor(
    private env: 'stg' | 'prd' = 'stg',
    private versionName: string,
    private versionNumber: string,
  ) {
    this.client = CoreNetworking({
      baseUrl: `https://${this.getHost(env)}`,
    });
  }

  async fetchSettings(
    token: string,
    etag: string | undefined,
    country?: string | undefined,
    language?: string | undefined,
  ): Promise<AxiosResponse<SettingsResponse>> {
    const params: Record<string, string | undefined> = {
      platform: Platform.OS,
      versionName: this.versionName,
      versionNumber: this.versionNumber,
      country: country,
      language: language,
    };

    const headers: RawAxiosRequestHeaders = {
      Authorization: `Bearer ${token}`,
    };

    if (etag) {
      headers['If-None-Match'] = etag;
    }

    return this.client.get('/settings', {
      params: params,
      headers: headers,
    });
  }
}

export default SettingsApiService;
